(function () {
  // Known bot/spam domains — add more here as you discover them.
  var BLOCKED_SUFFIXES = [
    'meta1.in.net', 'pifpaf.space', 'ge-credit.store', 'ge-credit.ru',
    'xrust.club', 'zlot555.com', 'imails.site', 'softdisc.site',
    'vmailer.site', 'cocaine-in-kyiv.online', 'tupop.online',
    'mymailer.buzz', 'filmkachat.ru', 'vykup-auto123.ru', 'adann.xyz',
    'webstor-globalyou.store', 'ui.dogle.info'
  ];

  var ERROR_MSG = 'Please enter a valid email address.';

  // ─── HELPERS ─────────────────────────────────────────────────────────────
  function getDomain(email) {
    var parts = email.split('@');
    return parts.length === 2 ? parts[1].toLowerCase() : '';
  }

  function isBlockedByList(email) {
    var domain = getDomain(email);
    if (!domain) return false;
    for (var i = 0; i < BLOCKED_SUFFIXES.length; i++) {
      if (domain === BLOCKED_SUFFIXES[i] || domain.endsWith('.' + BLOCKED_SUFFIXES[i])) {
        return true;
      }
    }
    return false;
  }

  function showError(input, msg) {
    clearError(input);
    var err = document.createElement('span');
    err.className = 'email-validator-error';
    err.setAttribute('role', 'alert');
    err.style.cssText = 'display:block;color:#c0392b;font-size:12px;margin-top:4px;font-family:inherit;';
    err.textContent = msg;
    input.setAttribute('aria-invalid', 'true');
    input.parentNode.insertBefore(err, input.nextSibling);
  }

  function clearError(input) {
    input.removeAttribute('aria-invalid');
    var existing = input.parentNode.querySelector('.email-validator-error');
    if (existing) existing.remove();
  }

  // ─── FORM INTERCEPTION ───────────────────────────────────────────────────
  function attachToForm(form) {
    if (form._emailValidatorAttached) return;
    form._emailValidatorAttached = true;

    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="email"], input[name="contact[email]"], input[name="email"]');
      if (!input) return;

      var email = input.value.trim();
      if (!email) return;

      clearError(input);

      if (isBlockedByList(email)) {
        e.preventDefault();
        showError(input, ERROR_MSG);
      }
    });
  }

  // ─── OBSERVE DOM FOR KLAVIYO FORMS ──────────────────────────────────────
  function attachToAllForms() {
    var forms = document.querySelectorAll(
      // back-in-stock: these addresses now go straight to Klaviyo, so junk domains
      // cost deliverability rather than just cluttering an inbox.
      'form[id^="newsletter-"], form[id="contact_form"], .klaviyo-form form, [class*="klaviyo"] form, form[data-form-spec], form.back-in-stock-form'
    );
    forms.forEach(attachToForm);
  }

  // MutationObserver to catch Klaviyo popup forms injected after page load
  var observer = new MutationObserver(function () {
    attachToAllForms();
  });

  document.addEventListener('DOMContentLoaded', function () {
    attachToAllForms();
    observer.observe(document.body, { childList: true, subtree: true });
  });

  // Also run immediately if DOM is already ready
  if (document.readyState !== 'loading') {
    attachToAllForms();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Expose the blocklist check so other scripts can defer to it instead of
  // keeping a second copy of the domain list. wishlist.js uses this before
  // sending a back-in-stock address to Klaviyo.
  window.PWEmailBlocklist = isBlockedByList;
})();
